// Generated by scripts/discover.mjs. Don't edit: add or rename a file instead (CLAUDE.md).

import type { SpecMap, SpecsIn } from "@adea/actions/spec";

/** Every spec file the web knows (`*.specs.ts`), loaded the first time a screen names one of its actions. */
export const SPEC_FILES = {
  "actions/company/company": () => import("@adea/actions/company/company.specs"),
  "actions/connectors/connectors": () => import("@adea/actions/connectors/connectors.specs"),
  "actions/platform/api-keys": () => import("@adea/actions/platform/api-keys.specs"),
  "actions/platform/runs": () => import("@adea/actions/platform/runs.specs"),
  "connect/code/actions/code": () => import("@adea/connect/code/actions/code.specs"),
  "connect/data/actions/files": () => import("@adea/connect/data/actions/files.specs"),
  "connect/data/actions/keys": () => import("@adea/connect/data/actions/keys.specs"),
  "connect/data/actions/links": () => import("@adea/connect/data/actions/links.specs"),
  "connect/data/actions/query": () => import("@adea/connect/data/actions/query.specs"),
  "connect/data/actions/signin": () => import("@adea/connect/data/actions/signin.specs"),
  "connect/data/actions/sources": () => import("@adea/connect/data/actions/sources.specs"),
  "connect/shops/actions/shops": () => import("@adea/connect/shops/actions/shops.specs"),
  "guardian/actions/guardian": () => import("@adea/guardian/actions/guardian.specs"),
  "platform/billing/actions/billing": () => import("@adea/platform/billing/actions/billing.specs"),
  "platform/demo/actions/demo": () => import("@adea/platform/demo/actions/demo.specs"),
  "platform/mcp/agents": () => import("@adea/platform/mcp/agents.specs"),
  "platform/settings/actions/access": () => import("@adea/platform/settings/actions/access.specs"),
  "platform/settings/actions/agreements": () => import("@adea/platform/settings/actions/agreements.specs"),
  "platform/settings/actions/brand": () => import("@adea/platform/settings/actions/brand.specs"),
  "platform/settings/actions/company": () => import("@adea/platform/settings/actions/company.specs"),
  "platform/settings/actions/danger": () => import("@adea/platform/settings/actions/danger.specs"),
  "platform/settings/actions/decide": () => import("@adea/platform/settings/actions/decide.specs"),
  "platform/settings/actions/profile": () => import("@adea/platform/settings/actions/profile.specs"),
  "platform/settings/actions/signin": () => import("@adea/platform/settings/actions/signin.specs"),
  "platform/settings/actions/standins": () => import("@adea/platform/settings/actions/standins.specs"),
  "platform/settings/actions/team": () => import("@adea/platform/settings/actions/team.specs"),
  "platform/staff/actions/access": () => import("@adea/platform/staff/actions/access.specs"),
  "product/collab/actions/comments": () => import("@adea/product/collab/actions/comments.specs"),
  "product/collab/actions/follows": () => import("@adea/product/collab/actions/follows.specs"),
  "product/collab/actions/notes": () => import("@adea/product/collab/actions/notes.specs"),
  "product/core/core": () => import("@adea/product/core/core.specs"),
  "product/core/onboarding": () => import("@adea/product/core/onboarding.specs"),
  "product/lists/lists": () => import("@adea/product/lists/lists.specs"),
  "product/sharing/sharing": () => import("@adea/product/sharing/sharing.specs"),
  "product/watch/actions/act": () => import("@adea/product/watch/actions/act.specs"),
  "product/watch/actions/changes": () => import("@adea/product/watch/actions/changes.specs"),
  "product/watch/actions/goals": () => import("@adea/product/watch/actions/goals.specs"),
  "product/watch/actions/home": () => import("@adea/product/watch/actions/home.specs"),
  "product/watch/actions/insights": () => import("@adea/product/watch/actions/insights.specs"),
  "product/watch/actions/measures": () => import("@adea/product/watch/actions/measures.specs"),
  "product/watch/actions/timeline": () => import("@adea/product/watch/actions/timeline.specs"),
  "reach/chat/slack/actions/connection": () => import("@adea/reach/chat/slack/actions/connection.specs"),
  "reach/chat/teams/actions/connection": () => import("@adea/reach/chat/teams/actions/connection.specs"),
  "reach/delivery/webhooks": () => import("@adea/reach/delivery/webhooks.specs"),
  "reach/notify/actions/install": () => import("@adea/reach/notify/actions/install.specs"),
  "reach/notify/actions/notifications": () => import("@adea/reach/notify/actions/notifications.specs"),
  "reach/notify/actions/preferences": () => import("@adea/reach/notify/actions/preferences.specs"),
} as const;

export type SpecFile = keyof typeof SPEC_FILES;

/** Which files define the actions whose name starts with a word. */
export const PREFIXES: Readonly<Record<string, readonly SpecFile[]>> = {
  access: ["platform/settings/actions/access"],
  activity: ["product/watch/actions/act"],
  agents: ["platform/mcp/agents"],
  agreements: ["platform/settings/actions/agreements"],
  apiKeys: ["actions/platform/api-keys"],
  areas: ["product/core/core"],
  billing: ["platform/billing/actions/billing"],
  brand: ["platform/settings/actions/brand"],
  brief: ["product/watch/actions/act"],
  changes: ["product/watch/actions/changes"],
  code: ["connect/code/actions/code"],
  comments: ["product/collab/actions/comments"],
  company: ["actions/company/company", "platform/settings/actions/company", "platform/settings/actions/danger", "platform/settings/actions/signin", "platform/settings/actions/standins"],
  connectors: ["actions/connectors/connectors"],
  data: ["connect/data/actions/files", "connect/data/actions/keys", "connect/data/actions/links", "connect/data/actions/query", "connect/data/actions/signin", "connect/data/actions/sources"],
  demo: ["platform/demo/actions/demo"],
  drafts: ["product/watch/actions/act"],
  escalation: ["product/watch/actions/act"],
  exports: ["product/sharing/sharing"],
  follows: ["product/collab/actions/follows"],
  goals: ["product/watch/actions/goals"],
  guardian: ["guardian/actions/guardian", "platform/settings/actions/decide"],
  home: ["product/watch/actions/home"],
  insights: ["product/watch/actions/insights"],
  keep: ["product/core/core", "product/watch/actions/measures"],
  library: ["product/core/core"],
  lists: ["product/lists/lists"],
  measures: ["product/watch/actions/measures"],
  notes: ["product/collab/actions/notes"],
  notifications: ["reach/notify/actions/notifications", "reach/notify/actions/preferences"],
  onboarding: ["product/core/onboarding"],
  pages: ["product/core/core"],
  playbooks: ["product/watch/actions/act"],
  profile: ["platform/settings/actions/profile"],
  reach: ["reach/notify/actions/install"],
  recipes: ["product/core/core"],
  routines: ["product/core/core"],
  runs: ["actions/platform/runs"],
  sees: ["product/core/core"],
  sharing: ["product/sharing/sharing"],
  shops: ["connect/shops/actions/shops"],
  slack: ["reach/chat/slack/actions/connection"],
  staffAccess: ["platform/staff/actions/access"],
  team: ["actions/company/company", "platform/settings/actions/team"],
  teams: ["reach/chat/teams/actions/connection"],
  threads: ["product/core/core"],
  timeline: ["product/watch/actions/timeline"],
  understanding: ["product/core/core"],
  value: ["product/watch/actions/act"],
  webhooks: ["reach/delivery/webhooks"],
};

/** Every action the web knows, by name: the typed client's types. */
export type WebSpecs = SpecMap<
  | SpecsIn<typeof import("@adea/actions/company/company.specs")>
  | SpecsIn<typeof import("@adea/actions/connectors/connectors.specs")>
  | SpecsIn<typeof import("@adea/actions/platform/api-keys.specs")>
  | SpecsIn<typeof import("@adea/actions/platform/runs.specs")>
  | SpecsIn<typeof import("@adea/connect/code/actions/code.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/files.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/keys.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/links.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/query.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/signin.specs")>
  | SpecsIn<typeof import("@adea/connect/data/actions/sources.specs")>
  | SpecsIn<typeof import("@adea/connect/shops/actions/shops.specs")>
  | SpecsIn<typeof import("@adea/guardian/actions/guardian.specs")>
  | SpecsIn<typeof import("@adea/platform/billing/actions/billing.specs")>
  | SpecsIn<typeof import("@adea/platform/demo/actions/demo.specs")>
  | SpecsIn<typeof import("@adea/platform/mcp/agents.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/access.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/agreements.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/brand.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/company.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/danger.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/decide.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/profile.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/signin.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/standins.specs")>
  | SpecsIn<typeof import("@adea/platform/settings/actions/team.specs")>
  | SpecsIn<typeof import("@adea/platform/staff/actions/access.specs")>
  | SpecsIn<typeof import("@adea/product/collab/actions/comments.specs")>
  | SpecsIn<typeof import("@adea/product/collab/actions/follows.specs")>
  | SpecsIn<typeof import("@adea/product/collab/actions/notes.specs")>
  | SpecsIn<typeof import("@adea/product/core/core.specs")>
  | SpecsIn<typeof import("@adea/product/core/onboarding.specs")>
  | SpecsIn<typeof import("@adea/product/lists/lists.specs")>
  | SpecsIn<typeof import("@adea/product/sharing/sharing.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/act.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/changes.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/goals.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/home.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/insights.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/measures.specs")>
  | SpecsIn<typeof import("@adea/product/watch/actions/timeline.specs")>
  | SpecsIn<typeof import("@adea/reach/chat/slack/actions/connection.specs")>
  | SpecsIn<typeof import("@adea/reach/chat/teams/actions/connection.specs")>
  | SpecsIn<typeof import("@adea/reach/delivery/webhooks.specs")>
  | SpecsIn<typeof import("@adea/reach/notify/actions/install.specs")>
  | SpecsIn<typeof import("@adea/reach/notify/actions/notifications.specs")>
  | SpecsIn<typeof import("@adea/reach/notify/actions/preferences.specs")>
>;
